module.exports = __webpack_public_path__ + "static/media/blog.9820d8a8.svg";